/* global $ */

// Breakpoints
const media = {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1200,
};

// Smooth scroll with hash change
$('a[href*="#"]:not([href="#"])').on('click', function foo() {
  if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
    const href = this.hash;
    let target = $(this.hash);
    target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top,
      }, 1000, () => {
        window.location.hash = href;
      });
      return false;
    }
  }
});

$('.js-gallery').slick({
  slidesToScroll: 1,
  slidesToShow: 4,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 641,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1,
      },
    },
  ],
});


$('.home-slider').slick({
  slidesToScroll: 1,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  fade: true,
  speed: 500,
  arrows: false,
  cssEase: 'linear',
  dots: true,
});

$('.js-home-intro-slides').slick({
  slidesToScroll: 1,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  fade: false,
  speed: 500,
  arrows: false,
  cssEase: 'linear',
  dots: false,
});

// Gmap
var styles= [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#46bcec"},{"visibility":"on"}]}];

function mapInitialize() {
  if ($('#gmap').length) {
    var map = new google.maps.Map(document.getElementById('gmap'), {
      zoom: 15,
      center: new google.maps.LatLng(51.762507, 18.082151),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      scrollwheel: false,
      navigationControl: false,
      mapTypeControl: false,
      scaleControl: false,
      draggable: true,
      styles: styles
    });
  }

  var marker = new google.maps.Marker({
    position: new google.maps.LatLng(51.762507, 18.082151),
    icon: 'img/marker.png',
    map: map
  });
}

google.maps.event.addDomListener(window, 'load', mapInitialize);

// PAGE NAVIGATION trigger
$('.js-nav-trigger').on('click', function foo(e) {
  $(this).toggleClass('is-active');
  e.stopPropagation();
  e.preventDefault();

  $('.nav-container').toggleClass('is-active');
  $('body').toggleClass('is-off');
});

$('.gallery a').magnificPopup({
  type: 'image',
  gallery: {
    enabled: true
  }
});

$('.js-enlarge').magnificPopup({
  type: 'image',
  gallery: {
    enabled: false
  }
});


function getScrollbarWidth() {
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
// force scrollbars
  outer.style.overflow = "scroll";

// add innerdiv
  var inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;

// remove divs
  outer.parentNode.removeChild(outer);

  return widthNoScroll - widthWithScroll;
}
console.log(getScrollbarWidth())